import './FinalCTASection.scss'

const FinalCTASection = () => (
  <section className="lnn-section lnn-finalCtaSection">
    <div className="lnn-shell" data-reveal="up">
      <div className="lnn-finalCtaSection__layout">
        <div className="lnn-finalCtaSection__content">
          <h2>Explore LeaderBridge</h2>
          <p>See how execution calibration works in practice.</p>
        </div>

        <div className="lnn-finalCtaSection__actions">
          <a className="lnn-ctaLink lnn-ctaLink--secondary" href="/implementation">
            View Implementation Support
          </a>
          <a
            className="lnn-ctaLink"
            href="https://leaderbridge.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Explore LeaderBridge
          </a>
        </div>
      </div>
    </div>
  </section>
)

export default FinalCTASection
